import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationCA from './locales/ca/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  ca: {
    translation: translationCA
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // El català és l'idioma de referència, no l'anglès.
    //
    // Amb `fallbackLng: 'en'`, un navegador configurat en castellà —que no és
    // cap raresa a l'aula— no trobava recursos per a 'es' i queia a l'anglès,
    // que és justament l'idioma on el contingut de tres de les quatre missions
    // no existeix: l'alumne es trobava una pantalla de guionets. Ara qualsevol
    // idioma que no sigui l'anglès explícit acaba en català, que és l'únic
    // idioma complet.
    fallbackLng: 'ca',
    // Sense això, 'es-ES' o 'ca-ES' es tractaven com a idiomes propis i no
    // coincidien amb cap recurs. `languageOnly` els redueix a 'es'/'ca', i
    // `supportedLngs` fa que el que no coneixem caigui al fallback.
    supportedLngs: ['ca', 'en'],
    load: 'languageOnly',
    debug: false,

    interpolation: {
      escapeValue: false // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    }
  });

export default i18n;